module.exports = __webpack_public_path__ + "static/media/rom16.d9d30d3e.jpg";